import { useQuery, useMutation } from '@tanstack/react-query';

// Services
import { getDashboardFilters, postDashboardFilters } from './dashboardFiltersService';

export const DASHBOARD_FILTERS_QUERY_KEY = 'dashboardFilters';

/**
 * Get manager dashboard filters
 * @param {{path: string, contexte?: string | null}} [params = {}] - The query params
 * @param {QueriesOptions} [options = {}] - The query options
 * @returns {import('@tanstack/react-query').UseQueryResult<ApiManagerDashboardFilters, Error>} The manager dashboard filters
 */
export const useDashboardFilters = (params = { path: '' }, options = {}) => {
  const { path, contexte = null } = params;
  return useQuery({
    queryKey: [DASHBOARD_FILTERS_QUERY_KEY, path, contexte],
    queryFn: () => getDashboardFilters(path, contexte),
    ...options,
  });
};

/**
 * Post manager dashboard filters
 * @param {string} path - The path of the dashboard
 * @param {import('@tanstack/react-query').UseMutationOptions<ApiManagerDashboardFilters, Error, ApiManagerDashboardFiltersCreate, unknown>} [options = {}] - The mutation options
 * @param {string | null} [contexte] - The context (optional)
 * @returns {import('@tanstack/react-query').UseMutationResult<ApiManagerDashboardFilters, Error, ApiManagerDashboardFiltersCreate, unknown>} The manager dashboard filters mutation
 */
export const useDashboardFiltersMutation = (path, options = {}, contexte = null) => useMutation({
  mutationFn: (data) => postDashboardFilters(path, data, contexte),
  ...options,
});
